import { createContext, useContext } from 'react';

/**
 * Onde a trilha é DESENHADA (a faixa superior, ao lado do nome de quem está
 * logado) não é onde ela é DECLARADA (a página, única que sabe a hierarquia da
 * linha aberta). Este slot carrega o nó de destino para baixo; o `PageHeader`
 * porta o conteúdo para cima com `createPortal`.
 *
 * A alternativa — cada página empurrando a trilha para um estado global no
 * layout — trocaria uma linha de JSX por um efeito que dispara a cada
 * navegação, com a trilha da tela anterior visível no intervalo.
 *
 * `null` = nenhuma faixa montada (página fora do `AppShell`, teste isolado).
 * Nesse caso o `PageHeader` desenha a trilha no lugar antigo, acima do título:
 * a trilha nunca some por falta de moldura.
 */
export const BreadcrumbSlotContext = createContext<HTMLElement | null>(null);

export function useBreadcrumbSlot(): HTMLElement | null {
  return useContext(BreadcrumbSlotContext);
}
